import React, { useState, useEffect } from "react";
import { Form, Button, Col, Row, Table, Container } from "react-bootstrap";
import Select from "react-select";
import { saveAs } from "file-saver";

const TestCase = ({
  testCases,
  setSelectedTestCase,
  selectedTestCase,
  userStoryID,
  setUserStoryID,
  testingType,
  setTestingType,
  coverage,
  setCoverage,
  method,
  setMethod,
  file,
  setFile,
  title,
  setTitle,
  description,
  setDescription,
  acceptanceCriteria,
  setAcceptanceCriteria,
  methodOptions,
  errors,
  setErrors,
  handleSubmit,
  handleCreateNewTestCase: parentHandleCreateNewTestCase,
  inputData,
  setInputData,
  isUploading,
  progress,
  typeOptions,
  testOptions,
  storeSingelRes,
}) => {
  const headersByTestingType = {
    API: [
      "Test Case ID",
      "Test Case Title",
      "Test Case Description",
      "Request Method",
      "API Endpoint",
      "Request Payload",
      "Test Steps",
      "Expected Result",
    ],
    UI: [
      "Test Case ID",
      "Test Case Title",
      "Test Case Description",
      "Test Steps",
      "Test Data",
      "Expected Result",
    ],
    DB: [
      "Test Case ID",
      "Test Case Title",
      "Test Case Description",
      "Database Operation",
      "Test Steps",
      "Test Data",
      "Expected Result",
    ],
  };
  
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const dataToDisplay =
    selectedTestCase?.test_case?.length > 0
      ? selectedTestCase.test_case
      : inputData?.generated_test_cases;
  useEffect(() => {
    setCurrentPage(1);
    setSelectedRows([]);
  }, [dataToDisplay]);
  // const tableHeaders = dataToDisplay?.length
  //   ? Object.keys(dataToDisplay[0])
  //   : [];
  const testingTypeValue =
  storeSingelRes?.testing_type || testingType?.value || testingType;

const tableHeaders = headersByTestingType[testingTypeValue] || [];

  const paginatedData = dataToDisplay?.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );
  const totalPages = Math.ceil((dataToDisplay?.length || 0) / rowsPerPage);
  const handleCopy = () => {
    const rowsToUse = selectedRows?.length > 0 ? selectedRows : dataToDisplay;

    const content = [
      tableHeaders?.join("\t"),
      ...rowsToUse?.map((row) =>
        tableHeaders?.map((h) => JSON.stringify(row[h]) ?? "").join("\t")
      ),
    ].join("\n");

    navigator.clipboard.writeText(content);
  };
  const handleExportCSV = () => {
    if (!dataToDisplay?.length) return;

    const rowsToUse = selectedRows?.length > 0 ? selectedRows : dataToDisplay;

    const escapeForCSV = (value) => {
      if (value == null) return "";
      if (typeof value === "object") value = JSON.stringify(value);
      let str = value.toString().replace(/"/g, '""');
      if (str.startsWith("=")) str = "'" + str;
      return `"${str}"`;
    };

    const csvRows = [
      tableHeaders?.join(","),
      ...rowsToUse?.map((row) =>
        tableHeaders?.map((header) => escapeForCSV(row[header])).join(",")
      ),
    ];

    const blob = new Blob([csvRows.join("\n")], {
      type: "text/csv;charset=utf-8;",
    });

    const idForFileName = selectedTestCase?.userStoryID || userStoryID;
    saveAs(blob, `TestCases_${idForFileName}.csv`);
  };

  const handleBackToForm = () => {
    parentHandleCreateNewTestCase();
    setInputData(null);
    setSelectedRows([]);
    setCurrentPage(1);
    setSelectedTestCase([]);
  };

  const showTable = dataToDisplay && dataToDisplay?.length > 0;
  const userStoryIDFromStore = storeSingelRes?.user_story_id || userStoryID;
  const titleFromStore = storeSingelRes?.user_story_title || title;
  const methodFromStore = storeSingelRes?.method || method?.label;
  const formatHeader = (key) => key.replace(/_/g, " ")

  // Utility to safely get value
  const formatCellValue = (value) =>
    typeof value === "object" && value !== null
      ? JSON.stringify(value)
      : value ?? "";
  // const dataKeys =
  //   paginatedData?.length > 0 ? Object.keys(paginatedData[0]) : [];
    const dataKeys = tableHeaders;
  return (
    <Container fluid className="p-0">
      {
        showTable ? (
          <Row>
            <Col md={12}>
              <div className="d-flex justify-content-between align-items-center rounded p-3 bg-white border mb-2">
                <div>
                  <h6 className="mb-1 fw-bold">Test Cases</h6>
                  <p className="mb-0 text-muted">
                    <strong>User Story ID:</strong> {userStoryIDFromStore}{" "}
                    <br />
                    <strong>User Story Title: </strong> {titleFromStore}
                    <br />
                    <strong>Method:</strong> {methodFromStore}
                  </p>
                </div>
                <div className="d-flex gap-2 align-items-center">
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={handleCopy}
                  >
                    📋 Copy
                  </Button>
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={handleExportCSV}
                  >
                    ⬇ Export - CSV
                  </Button>
                  <Button
                    variant="link"
                    size="sm"
                    className="text-decoration-none text-primary"
                    onClick={handleBackToForm}
                  >
                    ← Back to Form
                  </Button>
                </div>
              </div>

              <div
                className="rounded border bg-white p-3"
                style={{
                  maxHeight: "500px",
                  overflowY: "auto",
                  maxWidth: "74vw",
                }}
              >
                <Table striped bordered hover responsive>
                  <thead
                    style={{
                      position: "sticky",
                      top: 0,
                      background: "#f8f9fa",
                      zIndex: 2,
                    }}
                  >
                    <tr>
                      {dataKeys?.map((key, index) => (
                        <th
                          key={index}
                          style={{
                            whiteSpace: "nowrap",
                            fontWeight: "bold",
                            fontSize: "13px",
                          }}
                        >
                          {formatHeader(key)}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedData?.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {dataKeys?.map((key, colIndex) => (
                          <td key={colIndex}>{formatCellValue(row[key])}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              <div className="d-flex justify-content-center align-items-center mt-3 gap-2">
                <Button
                  size="sm"
                  variant="outline-secondary"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((prev) => prev - 1)}
                >
                  ← Prev
                </Button>
                {Array.from({ length: totalPages }, (_, index) => (
                  <Button
                    key={index}
                    size="sm"
                    variant={index + 1 === currentPage ? "primary" : "light"}
                    className="mx-1"
                    onClick={() => setCurrentPage(index + 1)}
                  >
                    {index + 1}
                  </Button>
                ))}
                <Button
                  size="sm"
                  variant="outline-secondary"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((prev) => prev + 1)}
                >
                  Next →
                </Button>
              </div>
            </Col>
          </Row>
        ) : <Row className="pt-2">
        <Col md={12}>
          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>User Story ID</Form.Label>
                  <Form.Control
                    type="text"
                    value={userStoryID}
                    onChange={(e) => {
                      setUserStoryID(e.target.value);
                      if (e.target.value) {
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          userStoryID: null,
                        }));
                      }
                    }}
                  />
                  {errors.userStoryID && (
                    <small className="text-danger">
                      {errors.userStoryID}
                    </small>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Testing Type</Form.Label>
                  <Select
                    options={typeOptions}
                    value={testingType}
                    onChange={(selectedOption) => {
                      setTestingType(selectedOption);
                      if (selectedOption) {
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          testingType: null,
                        }));
                      }
                    }}
                    placeholder="Select testing type"
                  />
                  {errors.testingType && (
                    <small className="text-danger">
                      {errors.testingType}
                    </small>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Coverage</Form.Label>
                  <Select
                    options={testOptions}
                    isMulti={false}
                    value={coverage}
                    onChange={(selectedOptions) => {
                      setCoverage(selectedOptions || []);
                      if (selectedOptions) {
                        // Check if selectedOptions is not null/undefined
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          coverage: null,
                        }));
                      }
                    }}
                    placeholder="Select coverage"
                  />
                  {errors.coverage && (
                    <small className="text-danger">{errors.coverage}</small>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Method</Form.Label>
                  <Select
                    options={methodOptions}
                    value={method}
                    onChange={(selectedOption) => {
                      setMethod(selectedOption);
                      if (selectedOption) {
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          method: null,
                        }));
                      }
                    }}
                    placeholder="Select method"
                  />
                  {errors.method && (
                    <small className="text-danger">{errors.method}</small>
                  )}
                </Form.Group>
              </Col>
            </Row>
            {method?.value === "Internal Documents" && (
              <Form.Group className="mb-3">
                <Form.Label>Upload files</Form.Label>
                <br />
                <input
                  type="file"
                  accept=".doc,.docx,.pdf,.csv,.xlsx"
                  onChange={(e) => {
                    setFile(e.target.files[0]);
                    if (e.target.files[0]) {
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        file: null,
                      }));
                    }
                  }}
                />
                {errors.file && (
                  <small className="text-danger">{errors.file}</small>
                )}
                <p style={{ fontSize: "12px", color: "gray" }}>
                  Accepted file types: DOCX, PDF, CSV, XLSX
                </p>
              </Form.Group>
            )}
            <Form.Group className="mb-3">
              <Form.Label>User Story Title</Form.Label>
              <Form.Control
                type="text"
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                  if (e.target.value) {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      title: null,
                    }));
                  }
                }}
              />
              {errors.title && (
                <small className="text-danger">{errors.title}</small>
              )}
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>User Story Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                placeholder="Enter user story description along with prerequisites"
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                  if (e.target.value) {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      description: null,
                    }));
                  }
                }}
              />
              {errors.description && (
                <small className="text-danger">{errors.description}</small>
              )}
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Acceptance Criteria</Form.Label>
              <Form.Control
                type="text"
                as="textarea"
                rows={4}
                value={acceptanceCriteria}
                onChange={(e) => {
                  setAcceptanceCriteria(e.target.value);
                  if (e.target.value) {
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      acceptanceCriteria: null,
                    }));
                  }
                }}
              />
              {errors.acceptanceCriteria && (
                <small className="text-danger">
                  {errors.acceptanceCriteria}
                </small>
              )}
            </Form.Group>
            <Form.Group className="d-flex align-items-center gap-2 mt-2">
              <Button
                type="submit"
                className="proceed-btn"
                disabled={isUploading}
              >
                {isUploading ? "Processing..." : "Proceed"}
              </Button>

              <Button
                className="create-new-btn px-3 ms-2"
                variant="outline-secondary"
                onClick={handleBackToForm} // Use the consolidated handler
                disabled={isUploading}
              >
                Reset & Create New
              </Button>

              {isUploading && (
                <div className="d-flex align-items-center ms-3">
                  <progress
                    value={progress}
                    max="100"
                    style={{
                      height: "6px",
                      width: "100px",
                    }}
                  />
                  <span className="ms-2 text-muted small">{progress}%</span>
                </div>
              )}
            </Form.Group>
          </Form>
        </Col>
      </Row>
      }
    </Container>
  );
};

export default TestCase;
